// extracted by mini-css-extract-plugin
module.exports = {"gallery":"HotelCardV2_gallery__smryi","navigation":"HotelCardV2_navigation__wg86T"};